import { useEffect, useRef, useState } from "react"

import HousePilotModalMetrics from "./Modal_Metrics";


export class DeviceBoxManagement {

    switchState() {
        if (!this._isDeviceAvailable) {
            return
        }
        const newStateActive = !this._isActive
        let promise
        if (!newStateActive) {
            promise = this._onStateChange(this._deviceName, 'SET_TEMP', this.minTargetTemp - 1)
        } else {
            promise = this._onStateChange(this._deviceName, 'SET_TEMP', this._deviceTargetTemperature)
        }

        promise.then(() => { }).catch(() => { })
    }

    changeTemp(direction, value = null) {
        if (!this._isDeviceAvailable) {
            return
        }
        if (this.refChangeTimeout?.current) {
            clearTimeout(this.refChangeTimeout.current)
        }
        const oldTargetTemp = this._deviceTargetTemperature
        let targetTemp = parseFloat(this._deviceTargetTemperature)

        if (value !== null) {
            if (parseFloat(value)) {
                targetTemp = parseFloat(value)
            } else {
                return
            }
        } else {
            if (direction === 'UP') {
                if (!this._isActive) {
                    targetTemp = this.minTargetTemp
                } else {
                    targetTemp += 0.5
                }
            } else if (direction === 'DOWN') {
                if (!this._isActive) {
                    return
                }
                targetTemp -= 0.5
            } else {
                return
            }
        }

        const delayChangeTempMs = 600
        const newTargetTemp = targetTemp
        this._setDeviceTargetTemperature(newTargetTemp)


        this.refChangeTimeout.current = setTimeout(() => {
            this._onStateChange(this._deviceName, 'SET_TEMP', newTargetTemp).then(() => {
            }).catch((e) => {
                this._setDeviceTargetTemperature(oldTargetTemp)
            })
        }, delayChangeTempMs)
    }

    getDeviceTargetTempToDisplay() {
        if (this._isActive) {
            return this._deviceTargetTemperature
        } else {
            return '--'
        }
    }

}



export default function HousePilotDeviceBox({ deviceName, deviceLabel, isActive, deviceCurrentTemp, deviceTargetTemp, mainMode, onStateChange, isDeviceAvailable = true, showModalMetricsTooltip = true, minTargetTemp = 16, maxTargetTemp = 30 }) {

    const [deviceTargetTpt, setDeviceTargetTpt] = useState(deviceTargetTemp)
    const effectiveIsActive = isDeviceAvailable && isActive

    useEffect(() => {
        setDeviceTargetTpt(deviceTargetTemp)
    }, [deviceTargetTemp])

    const manager = new DeviceBoxManagement()
    manager._isActive = effectiveIsActive
    manager._deviceTargetTemperature = deviceTargetTpt
    manager._setDeviceTargetTemperature = setDeviceTargetTpt
    manager._isDeviceAvailable = isDeviceAvailable
    manager.refChangeTimeout = useRef(null)
    manager.refTargetTemp = useRef(deviceTargetTemp)
    manager._deviceName = deviceName
    manager._deviceLabel = deviceLabel
    manager._onStateChange = onStateChange
    manager.minTargetTemp = minTargetTemp
    manager.maxTargetTemp = maxTargetTemp

    const [canShowModalMetrics, setCanShowModalMetrics] = useState(false)

    function onModalCloseHandler() {
        setCanShowModalMetrics(false)
    }

    let classActive = manager._isActive ? ' active' : ''
    if (classActive === ' active' && mainMode === 'cooling') {
        classActive += ' cooling'
    }
    const classUnavailable = isDeviceAvailable ? '' : ' unavailable'

    function displayModalMetricTooltip() {
        if (showModalMetricsTooltip === true) {
            return <i className="fa fa-info-circle float-left cursor-pointer" data-dname={deviceName} data-toggle="modal" data-target="#deviceMetrics" onClick={() => setCanShowModalMetrics(true)}></i>
        }
        return null
    }

    return (
        <>
            <div className={"m-1  deviceBox " + classActive + classUnavailable + (deviceName.includes('PARENTALE') ? ' col-6 col-md-6' : ' col-6 col-md-3')} id={"device-" + deviceName}>
                <h6>
                    {displayModalMetricTooltip()}
                    <strong className="float-center" style={{ fontSize: "0.85rem" }}>{deviceLabel}</strong>
                    <i className={"fa fa-power-off btn-power-switch float-center"} onClick={() => { manager.switchState() }}></i>
                    <br />
                </h6>
                {isDeviceAvailable && (
                    <>
                        <i className="fa fa-temperature-1"></i> <strong className="float-center">{deviceCurrentTemp} °C</strong><br />
                        <i className="fa fa-minus-circle cursor-pointer " onClick={() => { manager.changeTemp('DOWN') }}></i> {manager.getDeviceTargetTempToDisplay()} °C
                        <i className="fa fa-plus-circle cursor-pointer" onClick={() => { manager.changeTemp('UP') }}></i>
                    </>
                )}

                {!isDeviceAvailable && (
                    <div className="deviceBox-overlay"><span className="deviceBox-overlay-label">Hors ligne</span></div>
                )}
            </div>

            <HousePilotModalMetrics deviceLabel={deviceLabel} deviceName={deviceName} showModal={canShowModalMetrics} onModalClose={onModalCloseHandler} />
        </>
    )
}
